export default __webpack_public_path__ + "static/media/regulatory--truck-speed-limit-15--g1.f67bb65f.png";